module.exports = __webpack_public_path__ + "static/img/wuliuliucheng.fe1d9e56.png";